<template>
	<div>
		<div class="device-mobile" v-if="isMobile">
			<div class="construct">
				<div class="name" v-if="list[0]">{{ list[0].menuName ? list[0].menuName : '' }}</div>
				<div class="nameMain" v-if="info.content" v-html="formatRichText(info.content)"></div>
				<div class="name" v-if="list[1]">{{ list[1].menuName ? list[1].menuName : '' }}</div>
				<div class="technology">
					<div class="technologyImg">
						<img :src="webImg + snckData[num - 1].contentImg + imgCut(750,500)" alt="" v-if="snckData[num - 1]"
							@dragstart.prevent>
						<div class="anginImg">
							<div>{{ num }}/<span>{{ totalNum }}</span> </div>
							<div class="aLeft" @click="aLeftClick()"> <i class="el-icon-arrow-left"></i></div>
							<div class="aRight" @click="aRight()"> <i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="technologyName">
						<div class="anginText" v-if="snckData[num - 1]" v-html="snckData[num - 1].contentDescription">
							<!-- {{ snckData[num - 1].contentTitle ? snckData[num - 1].contentTitle : '' }} -->
						</div>
					</div>
				</div>
			</div>
			<img src="@/assets/007.png" alt="" class="bg">
		</div>
		<div class="device-pc" v-else>
			<div class="construct">
				<div class="navigation">
					<div class="navigationItem">
						<img src="../assets/home.png" alt="" @dragstart.prevent> <span @click="toTopImg()"
							style="cursor: pointer;">首页</span>
						<span style="color: black;">></span><span>党的建设</span><span
							style="color: black;">></span><span>党建概况</span>
					</div>
				</div>
				<div class="name" v-if="list[0]">{{ list[0].menuName ? list[0].menuName : '' }}</div>
				<div class="nameMain" v-if="info.content" v-html="formatRichText(info.content)"></div>
				<div class="name" style="margin-bottom: 20px;" v-if="list[1]">
					{{ list[1].menuName ? list[1].menuName : '' }}</div>
				<div class="technology">
					<div class="technologyImg">
						<img :src="webImg + snckData[num - 1].contentImg + imgCut(1920,1280)" alt="" v-if="snckData[num - 1]"
							@dragstart.prevent>
						<div class="anginImg">
							<div>{{ num }}/<span>{{ totalNum }}</span> </div>
							<div class="aLeft" @click="aLeftClick()"> <i class="el-icon-arrow-left"></i></div>
							<div class="aRight" @click="aRight()"> <i class="el-icon-arrow-right"></i></div>
						</div>
					</div>
					<div class="technologyName">
						<div class="anginText" v-if="snckData[num - 1]" v-html="snckData[num - 1].contentDescription">
							<!-- {{ snckData[num - 1].contentTitle ? snckData[num - 1].contentTitle : '' }} -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		menu,
		singleinfo,
		contentList
	} from '../api/api'
	export default {
		name: 'aboutUsTemplate',
		data() {
			return {
				parentId: this.$route.query.parentId || '', //二级菜单数组id
				list: [], //二级菜单数组
				info: {}, //富文本内容
				snckData: [],
				num: 1,
				totalNum: 1,
			}
		},
		mounted() {

		},
		created() {
			this.getList() //二级菜单数组
		},
		methods: {
			//首页
			toTopImg() {
				this.$router.push({
					path: '/home',
					query: {
						index: 0
					}
				})
			},
			//二级菜单数组
			getList() {
				menu(this.parentId).then(res => {
					this.list = res.data
					this.getSingleinfo(res.data[0].cmsLink) //富文本
					this.getContentList(res.data[1].menuId)
				})
			},
			//富文本
			getSingleinfo(id) {
				singleinfo(id).then(res => {
					this.info = res.data
					// console.log(res, 'getSingleinfo');
				})
			},
			getContentList(menuId, index) {
				contentList(menuId).then(res => {
					this.snckData = res.data
					this.totalNum = res.data.length
				})
			},
			aLeftClick() {
				if (this.num <= 1) {
					return this.num = this.totalNum
				}
				this.num--
			},
			aRight() {
				if (this.num >= this.totalNum) {
					return this.num = 1
				}
				this.num++
			},
			formatRichText(html) { //控制富文本图片大小
				let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
					match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
					// match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
					// match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
					return match;
				});
				newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
					match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi,
						'max-width:100%;');
					return match;
				});
				newContent = newContent.replace(/<br[^>]*\/>/gi, '');
			
				newContent = newContent.replace(/\<img/gi,
					'<img style="max-width:85%;height:auto;display:inline-block;margin:10rpx auto;text-indent: 0;"');
			
			
				return newContent;
			},


		}

	}
</script>

<style scoped lang="scss">
	.device-mobile {
		width: 100vw;
		position: relative;
		.construct {
			position: relative;
			z-index: 2;
			width: 9.466667rem;
			box-sizing: border-box;
			margin: 0 auto;
			padding-bottom: 2.613333rem;
			.name {
				font-size: 0.426667rem;
				font-family: Microsoft YaHei-Bold, Microsoft YaHei;
				font-weight: bold;
				color: #333333;
				margin: 0.666667rem 0 0.4rem;
			}
			.nameMain {
				font-size: 0.213333rem;
			}
			.technology {
				width: 100%;
				.technologyImg {
					position: relative;
					width: 100%;
					display: flex;
					img {
						width: 100%;
						height: 6.293333rem;
					}
					.anginImg {
						position: absolute;
						right: 0;
						bottom: 0;
						display: flex;
						align-items: center;
						font-size: 0.32rem;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #FFFFFF;
					
						span {
							font-size: 0.2rem;
						}
					
						.el-icon-arrow-left {
							color: #FFFFFF;
						}
						
						.el-icon-arrow-right {
							color: #FFFFFF;
						}
					
						.aLeft {
							width: 0.733333rem;
							height: 0.733333rem;
							background: rgba($color: #666666, $alpha: 0.5);
							margin-left: 0.266667rem;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}
					
						.aRight {
							width: 0.733333rem;
							height: 0.733333rem;
							background: rgba($color: #666666, $alpha: 0.5);
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;
						}
					}
				}
				.technologyName {
					padding: 0.266667rem;
					background-color: #FFFFFF;
					.anginText {
						font-size: 0.346667rem;
						font-family: Microsoft YaHei-Regular, Microsoft YaHei;
						font-weight: 400;
						color: #666666;
						line-height: 2;
					}
				}
			}
		}
		.bg {
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100vw;
			height: 8.56rem;
		}
	}
	.device-pc {
		.construct {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 100vw;
			min-height: 100vh;
			// background: url('../assets/bg.png') ;
			// background-size: 100% 100%;
			overflow: hidden;
			padding-bottom: 20px;

		}

		.topImg {
			width: 100vw;
			height: 520px;
			object-fit: contain;
		}

		.name {
			width: 1200px;
			margin: 0 auto;
			margin-top: 75px;
			font-size: 33px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #333333;
		}

		.nameMain {
			width: 1200px;
			margin: 0 auto;
			font-size: 18px;
			font-family: Microsoft YaHei-Regular, Microsoft YaHei;
			font-weight: 400;
			color: #000000;
			// margin-top: 85px;
			line-height: 39px;
			// height: 800px;

		}

		.technology {
			width: 1180px;
			margin: auto;
			height: 410px;
			background: #FFFFFF;
			display: flex;
			// align-items: end;
			margin-top: 20px;
			// overflow: hidden;
			box-shadow: 0 0 16px 5px #E0DEDF;
			margin-bottom: 60px;


			.technologyName {
				width: 602px;
				height: 410px;
				background: #FFFFFF;
				display: flex;
				justify-content: center;
				align-items: center;
				// padding: 0 60px;
				// box-sizing: border-box;
				// // padding-top: 160px;
				overflow: auto;

				.anginText {
					display: flex;
					justify-content: center;
					align-items: center;
					width: 550px;
					height: 350px;
					font-size: 18px;
					font-family: Microsoft YaHei-Regular, Microsoft YaHei;
					font-weight: normal;
					color: #666666;
					line-height: 34px;
				}
			}

			.technologyImg {
				// flex: 2;
				width: 598px;
				height: 398px;
				position: relative;
				margin-top: -10px;
				margin-left: -10px;

				img {
					width: 100%;
					height: 100%;
				}

				.anginImg {
					position: absolute;
					right: 0;
					bottom: 0px;
					display: flex;
					align-items: center;
					font-size: 24px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #FFFFFF;

					span {
						font-size: 15px;
						// background: #0175C2;
					}

					.el-icon-arrow-left {
						color: #FFFFFF;
					}

					.el-icon-arrow-right {
						color: #FFFFFF;
					}

					.aLeft {
						width: 55px;
						height: 55px;
						// background: #FFFFFF;
						// opacity: 0;
						// // background: raba(255,255,255,1);
						// background: #666666;
						background: rgba($color: #666666, $alpha: 0.5);
						margin-left: 35px;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
					}

					.aRight {
						width: 55px;
						height: 55px;
						background: rgba($color: #666666, $alpha: 0.5);
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
					}

					.aLeft:hover,
					.aRight:hover {
						background: #0175C2;
					}
				}
			}
		}

		.navigation {

			width: 100vw;
			background: #f5f5f5;
			display: flex;
			align-items: center;
			cursor: pointer;


			.navigationItem {
				width: 1200px;
				margin: 0 auto;
				display: flex;
				align-items: center;
				// margin-top: 15px;
				height: 36px;
				line-height: 36px;
				margin-bottom: 20px;
				padding-top: 15px;
				box-sizing: border-box;
				color: #1979b7;
				font-size: 20px;
			}

			img {
				width: 20px;
				height: 20px;
				margin-right: 7px;

			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/construct.vue